import { initContract } from "@ts-rest/core";
import { z } from "zod";

import { ProductLineSchema, ProductSchema } from "../types";
import { makeCreateInputSchema } from "../utils/zod-utils/makeCreateInputSchema";
import { makeUpdateInputSchema } from "../utils/zod-utils/makeUpdateInputSchema";

const c = initContract();

export const productLinesContract = c.router({
  createInline: {
    method: "POST",
    path: "/product-lines/quote-request-line/:id",
    body: makeCreateInputSchema(
      ProductLineSchema.omit({ productId: true }).merge(
        z.object({ product: makeCreateInputSchema(ProductSchema) }),
      ),
    ),
    responses: {
      201: ProductLineSchema.merge(z.object({ product: ProductSchema })),
    },
  },

  update: {
    method: "PUT",
    path: "/product-lines/:id",
    body: makeUpdateInputSchema(ProductLineSchema.merge(z.object({ product: ProductSchema }))),
    responses: {
      200: ProductLineSchema,
    },
  },

  delete: {
    method: "DELETE",
    path: "/product-lines/:id",
    body: z.object({}),
    responses: {
      204: z.object({}),
    },
  },
});
